import React from "react";
import { useState } from "react";
import {useDispatch} from 'react-redux';
import {getNameDogs} from '../acctions';
import s from '../css/search.module.css'

export default function SearchBar (){
    //const [currentPage,setCurrentPage]= useState(1) 
    const dispatch = useDispatch()
    const [name, setName] = useState('')
    
    function handleInputChange(e){
        e.preventDefault()
        setName(e.target.value)
    }
    function handleSubmit(e){
        e.preventDefault()
        dispatch(getNameDogs(name))
        setName("")
    }
    return (
    <div className={s.conten}>
        <form className={s.form}>
            <input
            type = 'text'
            placeholder="Search breeds"
            onChange={handleInputChange} value={name} />
            <button className={s.btn1} type="submit" onClick={handleSubmit}>Search</button>
        </form>
    </div>    
    )
}